module.exports = __webpack_public_path__ + "img/zanwushipin@2x.2c5ed104.png";